export const ADMIN = "admin";
export const COMPANY = "company";
export const TAX_PAYER = "taxpayer";
export const TAX_COLLECTOR = "taxcollector";
export const TAX_SUPERVISOR = "taxsupervisor";
export const TAX_ADMIN = "taxadmin";
export const TAX_SUPER_ADMIN = "taxsuperadmin";
export const COMPANY_ADMIN = "companyadmin";
export const DEALER = "dealer";

export const ROLES: any = {
  [ADMIN]: "Admin",
  [COMPANY]: "COMPANY",
  [COMPANY_ADMIN]: "COMPANY ADMIN",
  [DEALER]: "DEALER",
  [TAX_PAYER]: "TAX PAYER",
  [TAX_COLLECTOR]: "TAX COLLECTOR",
  [TAX_SUPERVISOR]: "TAX SUPERVISOR",
  [TAX_ADMIN]: "TAX ADMIN",
  [TAX_SUPER_ADMIN]: "TAX SUPER ADMIN",
};

export const validRoles = [
  {name: "Admin", value: ADMIN},
  {name: "Company", value: COMPANY},
  {name: "Company Admin", value: COMPANY_ADMIN},
  {name: "Dealer", value: DEALER},
  {name: "Tax Admin", value: TAX_ADMIN},
  {name: "Tax Super Admin", value: TAX_SUPER_ADMIN},
]


export const pageRoles = {
  superUser: [ADMIN],
  company: [COMPANY],
  companyAdmin: [COMPANY_ADMIN],
  dealer: [DEALER],
  taxSuperAdmin: [TAX_SUPER_ADMIN],
  taxAdmin: [TAX_ADMIN, TAX_SUPER_ADMIN],
  taxCollector: [TAX_COLLECTOR],
  taxPayer: [TAX_PAYER],
  taxSupervisor: [TAX_SUPERVISOR],
};

/**
 * Récupère le rôle effectif de l'utilisateur (un seul rôle à la fois).
 * Utilise la structure API : role à la racine ou dans user.
 * Fallback : username "superadmin" si l'API ne renvoie pas de rôle.
 */
export function getEffectiveUserRole(user: any): string {
  const role =
    user?.role ?? user?.user?.role ?? "";
  const normalized = String(role).toLowerCase().replace(/\s/g, "").trim();
  if (normalized) return normalized;

  const username = (user?.user?.username ?? user?.username ?? "")
    .toLowerCase()
    .trim();
  if (username === "superadmin") return "superadmin";

  return "";
}
